module.exports = __webpack_public_path__ + "img/5-4.dcd58722.svg";